var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5804 3.60059H5.52728C5.0182 3.60099 4.52019 3.74914 4.09367 4.02707C3.66716 4.305 3.33049 4.70075 3.12451 5.1663C2.91854 5.63185 2.85213 6.14717 2.93333 6.64973C3.01453 7.15229 3.23986 7.62047 3.58196 7.99746L12.2726 17.5553V26.5693C12.2727 26.7455 12.3224 26.9182 12.4161 27.0674C12.5098 27.2166 12.6436 27.3364 12.8023 27.4131C12.9291 27.4756 13.0687 27.5077 13.2101 27.5068C13.4232 27.5067 13.6298 27.4339 13.796 27.3006L15.5538 25.8943L18.4835 23.5506C18.5932 23.4628 18.6817 23.3515 18.7425 23.225C18.8034 23.0984 18.835 22.9598 18.8351 22.8193V17.5553L27.5257 7.99746C27.8678 7.62047 28.0931 7.15229 28.1744 6.64973C28.2556 6.14717 28.1891 5.63185 27.9832 5.1663C27.7772 4.70075 27.4405 4.305 27.014 4.02707C26.5875 3.74914 26.0895 3.60099 25.5804 3.60059Z",
    fill: "#481EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0cbdbedff260718f228efa6c2a0919cc.svg";
export { ForwardRef as ReactComponent };